<template>
  <div class="page">
    <project-page-header ref="pageHeader" show-steps show-tabs show-stat :id="projectId">
      <template v-slot:actions="{ data }">
        <a-space>
          <template v-if="data.state === 7">
           <a-button size="small" icon="form" type="indigo" @click="$router.push(`../report/draft?id=${projectId}`)">项目报告</a-button>
          </template>
        </a-space>
      </template>
    </project-page-header>
    <div class="v-px-md">
      <router-view />
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
export default {
  name: 'SchoolProjectView',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      stoping: false,
      concluding: false,
      closing: false,
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
      }
    },
  },
  created() {
    this.init()
  },
}
</script>
